<template>
  <div class="wrapper">
    <section class="container">

      <!-- <div style="display: flex; gap: 1em; z-index: 10000000;">
        <div @click="show('onboard')"> Onboard</div>
        <div @click="show('win')"> Win</div>
        <div @click="show('lose')"> Lose</div>
        <a :href="tweet">Tweet</a>
        <a :href="tweet">"{{ status }}"</a>
      </div> -->


      <Transition name="card">
        <div class="overlay" v-show="showCards.onboard || showCards.win || showCards.lose">
          <div class="transition-wrapper" v-if="showCards.onboard || showCards.win || showCards.lose">
            <div class="card" v-show="showCards.onboard">
              <div class="content">
                <h1>Let's Play</h1>
                <p>Guess the story by choosing the right emojis in the right order.</p>
                <button class="spacer" @click="showCards.onboard = false">Start playing</button>
              </div>
              <div class="confetti-bottom"></div>
            </div>

            <div class="card" v-show="showCards.win">
              <div class="content">
                <h1>Hooray!</h1>
                <p>Congratulations! You've solved the puzzle. This is today's Newsle story.</p>

                <div class="story">
                  <div class="story-lead">
                    <img :src="story.image" :alt="story.name" />
                    <h2>{{ story.name }}</h2>
                  </div>
                  <p>{{ story.synopsis }}</p>

                  <button @click="$router.push(`/story/${story.slug}`)">Read the full story</button>
                </div>

                <div class="social">
                  <h3>Share your results!</h3>
                  <div class="icons">
                    <button @click="share()">Share</button>
<!-- 
                    <a class="icon" :href="tweet" :target="inApp ? '' : '_blank'">
                      <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.2019 0H15.7738L10.1565 6.35337L16.7647 15H11.5918L7.5372 9.75721L2.90341 15H0.327863L6.33503 8.20312L0 0H5.30409L8.96522 4.79207L13.2019 0ZM12.2985 13.4784H13.7229L4.52815 1.44231H2.99812L12.2985 13.4784Z"
                          fill="white" />
                      </svg>
                    </a> -->
                    <!-- <a class="icon" href="">
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M2.82724 10.5223V18H6.91755V10.5223H9.96765L10.6024 7.08398H6.91755V5.86758C6.91755 4.05 7.63336 3.35391 9.48105 3.35391C10.0558 3.35391 10.5177 3.36797 10.7857 3.39609V0.277734C10.2815 0.140625 9.04733 0 8.33506 0C4.56563 0 2.82724 1.77539 2.82724 5.60391V7.08398H0.5V10.5223H2.82724Z"
                          fill="white" />
                      </svg>
                    </a> -->
                  </div>
                </div>
              </div>
              <div class="confetti-bottom"></div>
            </div>

            <div class="card" v-show="showCards.lose">
              <div class="content">
                <h1>Uh oh!</h1>
                <p>You're out of guesses 😥. This is today's Newsle story.</p>

                <div class="story">
                  <div class="story-lead">
                    <img :src="story.image" :alt="story.name" />
                    <h2>{{ story.name }}</h2>
                  </div>
                  <p>{{ story.synopsis }}</p>

                  <button @click="$router.push(`/story/${story.slug}`)">Read the full story</button>
                </div>

                <div class="social">
                  <h3>Share your attempt!</h3>
                  <div class="icons">
                    <button @click="share()">Share</button>
                    <!-- <a class="icon" @click="share()">
                      <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.2019 0H15.7738L10.1565 6.35337L16.7647 15H11.5918L7.5372 9.75721L2.90341 15H0.327863L6.33503 8.20312L0 0H5.30409L8.96522 4.79207L13.2019 0ZM12.2985 13.4784H13.7229L4.52815 1.44231H2.99812L12.2985 13.4784Z"
                          fill="white" />
                      </svg>
                    </a> -->
                    <!-- <a class="icon" href="">
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M2.82724 10.5223V18H6.91755V10.5223H9.96765L10.6024 7.08398H6.91755V5.86758C6.91755 4.05 7.63336 3.35391 9.48105 3.35391C10.0558 3.35391 10.5177 3.36797 10.7857 3.39609V0.277734C10.2815 0.140625 9.04733 0 8.33506 0C4.56563 0 2.82724 1.77539 2.82724 5.60391V7.08398H0.5V10.5223H2.82724Z"
                          fill="white" />
                      </svg>
                    </a> -->
                  </div>
                </div>
              </div>
              <div class="confetti-bottom"></div>
            </div>
          </div>
        </div>
      </Transition>

      <div class="header">
        <!-- <button class="back" @click="$router.push('/')">
          <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.07453 1.38703C7.39183 1.06972 7.39183 0.555277 7.07453 0.237976C6.75723 -0.0793253 6.24278 -0.0793253 5.92548 0.237976L0.237976 5.92548C-0.0793253 6.24278 -0.0793253 6.75723 0.237976 7.07453L5.92548 12.762C6.24278 13.0793 6.75723 13.0793 7.07453 12.762C7.39183 12.4447 7.39183 11.9303 7.07453 11.613L2.77405 7.3125H13C13.4487 7.3125 13.8125 6.94874 13.8125 6.5C13.8125 6.05127 13.4487 5.6875 13 5.6875H2.77405L7.07453 1.38703Z" fill="white"/>
          </svg>
        </button> -->
        <div class="brand"></div>
      </div>
      <div class="puzzle">
        <div class="clue-tag">{{ results.remain >= 5 ? `Solve today's puzzle` : `Clue #${5 - results.remain}` }}</div>
        <div class="clue">
          <div class="subtitles">
            <transition name="hint">
              <span class="pending_subtitles" :key="`hint-${results.remain}`">{{ hint }}</span>
            </transition>
          </div>
        </div>

        <div class="actions">
          <div class="guesses">
            <span class="remain">{{ results.remain }}</span>
            <span>guesses<br>remaining</span>
          </div>
          <div v-show="results.remain > 0">
            <button :disabled="!guesses_full" :class="{ 'disabled': !guesses_full }" @click="submitGuess()">{{
          guesses_full ? 'Check my Guess' : 'Pick 5 Emoji…' }}</button>
          </div>
        </div>

        <div class="cloud" :class="{ 'full': guesses_full }" ref="cloud">
          <div class="row" v-for="(row, i) in cloud" :key="i">
            <span class="emoji" v-for="(emoji, ii) in row" :key="ii" @click="toggleEmoji" :data-emoji="emoji"
              data-on="">{{ emoji }}</span>
          </div>
        </div>

        <main class="board">
          <div class="game">
            <span class="guess" v-for="(emoji, i) in guesses" :key="i" @click="toggleEmoji"
              :data-emoji="emoji == '?' ? '' : emoji">
              <span v-if="emoji !== '?'" class="guess-result" :key="`guess-result-${results.remain}-${i}`" :mark="`guess-result-${results.remain}-${i}`">{{ results.result[i] }}</span>
              {{ emoji }}
              <div class="reveal-clue" :class="{ 'enabled': hasemojiClue(i), 'disabled': !hasemojiClue(i), }"
                @click="showEmojiClue(i)">
                CLUE
              </div>
            </span>

          </div>

          <div class="guess-clue" v-show="clue" @click="showEmojiClue()">
            <transition name="fade">
              <span class="pending_subtitles" :key="emojiClue">{{ clue }}</span>
            </transition>
          </div>



          <!-- <div class="game result">
            <span class="guess" v-for="(emoji, i) in results.result" :key="i" :data-emoji="emoji ? '' : emoji">{{ emoji }}</span>
          </div>
          <div class="story" v-show="story.slug">
            <a :href="`/story/${story.slug}`" target="_blank">Read more (story-card should appear here) {{ story.name }}</a>
          </div> -->
        </main>
      </div>
    </section>
    <div class="confetti-top"></div>
    <div class="purp-grad"></div>
  </div>
</template>



<script>
import utils from '@assets/js/utils.js';
import story from '@assets/js/news/story-utils.js';

import Vue from 'vue';
import API from 'app/axios';
// import Subtitles from '@components/_v3.3/_common/Subtitles.vue';

export default {
  mixins: [story, utils],
  components: {
    // Subtitles,
  },
  data() {
    return {
      puzzle: {},
      current_guess: [null, null, null, null, null],
      result_log: [],
      results: {
        result: [null, null, null, null, null],
        remain: 5,
      },
      showClue: true,
      showCards: {
        onboard: true,
        win: false,
        lose: false,
      },
      emojiClues: [],
      emojiClue: null,
    };
  },
  mounted() {
    API
      .get('/puzzles/emoji/today', {})
      .then(response => {
        this.puzzle = response.data;
        this.emojiClues[0] = this.puzzle.clue;
      });
  },
  methods: {
    share() {
      this.EventBus.$emit('track:event', {
        event: 'newsle-share',
        props: { mode: 'Play' },
        detail: { detail_char: 'Share' },
      });
      if (this.hasApp) {
        this.EventBus.$emit("appCallback", {
          type: 'socialCallback',
          data: {
            social: 'url',
            link: `https://nourished.news/n/newsle`,
            message: `I just finished today's Newsle puzzle on Nourish 🗞️ ${this.result_log.join('%0A')}`
          }
        });
        return;
      } else {
        this.EventBus.$emit('layer:new', {
          component: 'message',
          opts: {
            heading: `Share your results`,
            message: `Let the world know about your Newsle score today.`,
            share: {
              url: `https://nourished.news/n/newsle`,
              message: `I just finished today's Newsle puzzle on Nourish 🗞️ ${this.result_log.join('%0A')}`
            }
          },
        });
      }
    },

    submitGuess() {
      if (!this.guesses_full) {
        console.warn(`Strange?  Guesses aren't full?`);
        return;
      }
      if (this.remain <= 0) {
        return;
      }

      this.emojiClue = null;

      this.haptic('medium');

      API
        .post('/puzzles/emoji', {
          guess: this.current_guess.join(','),
          try: this.attempt,
        })
        .then(response => {
          this.results = response.data;
          // stack the emoji clues..
          this.emojiClues[this.attempt - 1] = this.results.clue;
          // stack the guess history..
          this.result_log.push(this.results.result.join(''));
        });
    },

    toggleEmoji(e) {
      // get the emoji (could be a cloud button or guess button)
      let sEmoji = e.target?.dataset?.emoji;

      // a superfluous click on a null icon
      if (!sEmoji) {
        return;
      }

      this.haptic('light');

      // now find the corresponding cloud button
      let eButton = this.$refs.cloud.querySelector(`[data-emoji="${sEmoji}"]`);

      let bOn = eButton?.dataset?.on ? 1 : 0;

      // register (or deregister) the selection
      if (!bOn) {
        this.addEmoji(sEmoji);
      } else {
        this.removeEmoji(sEmoji);
      }

      // find & toggle

      eButton.dataset.on = bOn ? '' : 'on';

      // debug
    },

    addEmoji(sEmoji) {
      this.emojiClue = null;

      let iFirstBlank = this.current_guess.findIndex(s => !s);

      if (iFirstBlank == -1) {
        console.warn(`Strange. Can't add any more. We're full?`);
      }

      Vue.set(this.current_guess, iFirstBlank, sEmoji);

      this.haptic('light');
    },

    removeEmoji(sEmoji) {  
      this.emojiClue = null;
   
      let iFound = this.current_guess.findIndex(s => s == sEmoji);

      if (iFound == -1) {
        console.warn(`Strange. That emoji isn't in the guess?`);
      }

      this.results.result[iFound] = null;
      Vue.set(this.current_guess, iFound, null);

      this.haptic('light');
    },

    hasemojiClue(i) {
      return this.emojiClues.length >= i + 1;
    },

    showEmojiClue(i) {
      // toggle?
      if (i == this.emojiClue) {
        this.emojiClue = null;
        return;
      }

      // check it's a valid click? 
      if (!this.hasemojiClue(i)) {
        this.emojiClue = null;
        return;
      }

      // set the emojiClue index
      this.emojiClue = i;

      this.haptic('warning');
    },

    show(card) {
      this.showCards[card] = true;
    },

    haptic(note) {
      this.EventBus.$emit("device:haptic", note);
    },
  },
  computed: {
    status() {
      return this.results.status || 'new';
    },
    hint() {
      return this.results.hint || this.puzzle.hint || 'Loading…';
    },
    clue() {
      return this.emojiClue !== null ? this.emojiClues[this.emojiClue] : null;
    },
    cloud() {
      return this.puzzle.cloud ? [
        this.puzzle.cloud.slice(0, 6),
        this.puzzle.cloud.slice(6, 12),
        this.puzzle.cloud.slice(12, 18),
        this.puzzle.cloud.slice(18, 24),
      ] : [
        [],
      ];
    },
    guesses() {
      return this.current_guess.map(s => s || '?');
    },
    guesses_full() {
      return this.current_guess.findIndex(s => !s) == -1;
    },
    attempt() {
      return 6 - (this.results.remain || 5);
    },
    story() {
      return this.results?.story?.slug ? this.results.story : {};
    },

    inApp() {
      return this.$store.getters.inApp;
    },
    tweet() {
      let progress = this.result_log.join('%0A');
      let puzzle = this.puzzle.puzzle_name;
      return `https://twitter.com/intent/tweet?text=%23Newsle%20${puzzle}%0A%0A${progress}`;
    },
  },
  watch: {
    status(to) {
      switch (to) {
        case 'complete':
          this.showCards.win = true;
          break;
        case 'failed':
          this.showCards.lose = true;
          break;
      }
    }
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/__v6.scss';

$border-radius: 15px;
$purple: #9000D4;
$white: #fff;
$purple-faded-bg: rgba(144, 0, 212, 0.2);
$purple-box-shadow: 0px 4px 0px rgba(144, 0, 212, 0.4), 0px 0px 150px rgba(144, 0, 212, 0.1);
$yellow-box-shadow: 0px 4px 0px rgba(249, 222, 75, 0.4), 0px 0px 150px rgba(249, 222, 75, 0.1);

.confetti-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  max-width: 920px;
  margin: 0 auto;
  height: 8rem;
  z-index: 2;
  background-image: url('~@assets/images/confetti-stretch.png');
  background-size: cover;
  background-position: center;
}

.purp-grad {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50vh;
  width: 100%;
  z-index: 1;
  background: linear-gradient(180deg, rgba(144, 0, 212, 0) 0%, rgba(144, 0, 212, 0.5) 99.99%, rgba(144, 0, 212, 0) 100%);
}

.wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000B22;
  overflow: hidden;
  color: white;
  // padding-top: calc(env(safe-area-inset-top) + 0.2rem);

  .container {
    max-width: 600px;
    height: 100%;
    // min-height: 100vh;
    z-index: 10;

    .mobile & {
      width: 100%;
      // min-height: 100vh;
    }

    border-radius: 1em;
    padding: 1.5rem;

    display: flex;
    flex-direction: column;

    .header {
      flex-basis: 5em;
      text-align: center;
      line-height: 1.2;

      .back {
        position: absolute;
        z-index: 100000;
        top: calc(env(safe-area-inset-top) + 1.2rem);
        left: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        padding: 0;
        background: $purple;
      }

      .brand {
        width: 100%;
        height: 3rem;
        // background-image: url('~@assets/images/factle-brand.png');
        background-image: url('~@assets/images/newsle-brand.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }

    .puzzle {
      position: relative;
      margin-top: -1rem;
      gap: 0.5rem;
      flex-grow: 1;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 0.5rem;

      .clue-tag {
        position: absolute;
        background: $purple-tone-3;
        border-radius: $border-radius;
        padding: 0.65rem 0.8rem 0.8rem 0.8rem;
        box-shadow: $purple-box-shadow;
        font-weight: bold;
        font-size: 0.8rem;
        align-self: center;
        transform: rotate(-2deg);
      }

      .clue {
        width: 100%;
        border-radius: $border-radius;
        // background: $purple-faded-bg;
        background: $purple-tone-5;
        box-shadow: $purple-box-shadow;
        padding: 2.75rem 1.5rem 1.5rem 1.5rem;
        text-align: center;
        font-weight: bold;
        margin-top: 0.75rem;
        

        // .subtitles {
        //   position: relative;

        //   .pending_subtitles {
        //     position: absolute;
        //   }
        // }
      }

      .actions {
        display: flex;
        justify-content: space-between;
        align-items: center;

        button {
          border-radius: $border-radius;
          box-shadow: $yellow-box-shadow;

          &:disabled {
            opacity: .3;
            cursor: not-allowed;
          }
        }

        .guesses {
          display: flex;
          align-items: center;
          font-weight: bold;

          .remain {
            font-family: 'Creighton';
            font-size: 75px;
            text-shadow: $purple-box-shadow;
            color: $purple;
            margin-right: 1rem;
          }
        }
      }

      .cloud {
        font-size: 22px;
        min-height: 6em;
        display: flex;
        flex-direction: column;

        .row {
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          justify-content: space-between;

          .emoji {
            cursor: pointer;
            position: relative;
            z-index: 1;
            background: #192338;
            text-align: center;
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
            border-radius: 500px;
            border: 2px solid transparent;
            font-size: 25px;

            &[data-on="on"] {
              border: 2px solid $purple;
              background: $purple-faded-bg;
              box-shadow: $purple-box-shadow;
              // &::after {
              //   content: " ";
              //   background: rgba($purple-tone-3, 0.15);
              //   border-radius: 50%;
              //   border: 1px solid rgba($purple-tone-3, 0.85);
              //   position: absolute;
              //   inset: 0px;
              //   transform: translate(-3px, 0);
              //   z-index: -1;
              // }
            }
          }
        }

        &.full {
          .emoji:not([data-on="on"]) {
            opacity: 0.1;
            pointer-events: none;
          }
        }
      }


      .board {
        flex-basis: 70%;
        //--
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .game {
          width: 100%;
          margin: 1rem 0.5rem 0.5rem 0.5rem;
          font-size: 70px;
          display: flex;

          .guess {
            position: relative;
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 100%;
            padding: 2rem 0.8rem 0 0.8rem;
            font-size: 36px;
            cursor: pointer;

            &:not(:last-child) {
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                content: '';
                width: 1px;
                height: 100%;
                background: linear-gradient(transparent, $purple, transparent);
              }
            }

            .guess-result {
              position: absolute;
              top: 0;
              font-size: 20px;
              margin-bottom: 1rem;
              opacity: 0;

              animation: 1s ease-out 1 spin forwards;
            }
            &:nth-child(1) { .guess-result { animation-delay: 0.5s; }}
            &:nth-child(2) { .guess-result { animation-delay: 1.0s; }}
            &:nth-child(3) { .guess-result { animation-delay: 1.5s; }}
            &:nth-child(4) { .guess-result { animation-delay: 2.0s; }}
            &:nth-child(5) { .guess-result { animation-delay: 2.5s; }}

            .reveal-clue {
              font-size: 10px;
              font-weight: bold;
              color: $purple;
              border-radius: 5px;
              padding: 0.2rem 0.4rem 0.3rem 0.4rem;
              border: 1px solid $purple-tone-2;
              color: $purple-tone-2;
              margin-top: 1rem;
              transition: all .3s;

              &.disabled {
                opacity: 0.3;
              }

              &.enabled:hover {
                border: 1px solid $white;
                color: $white;
              }
            }
          }
        }

        .guess-clue {
          position: fixed;
          bottom: 1.2rem;
          left: 1rem;
          right: 1rem;
          font-size: 1rem;
          font-weight: bold;
          text-align: center;
          font-size: 14px;
          padding: 1rem 1rem;
          border-radius: $border-radius;
          background: $purple;
          box-shadow: $purple-box-shadow;
        }
      }
    }

    .overlay {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(2px);
      z-index: 10000;
      pointer-events: none;
      transition: all .5s;

      .transition-wrapper {
        position: absolute;
        bottom: .75em;
        left: .75em;
        right: .75em;
        // background: #03132F;
        z-index: 11000;
        pointer-events: all;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1em;
        transition: all .5s;

        .card {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          position: relative;
          width: 100%;
          height: 100%;
          padding: 2.5rem 2rem 3rem 2rem;
          border-radius: 1em;
          background: linear-gradient(180deg, #03132F 0%, rgba(144, 0, 212, 0.5) 99.99%);
          overflow: hidden;
          margin-bottom: calc(env(safe-area-inset-bottom) + 0.5rem);;

          .content {
            z-index: 1;

            .spacer {
              margin-top: 3rem;
            }

            .story {
              position: relative;
              margin: 1.5rem 0;
              background: $purple-faded-bg;
              box-shadow: $purple-box-shadow;
              padding: 1.5rem 1.5rem 2.5rem 1.5rem;
              width: 100%;
              text-align: left;
              border-radius: $border-radius;

              .story-lead {
                display: flex;
                align-items: center;
                margin-bottom: 0.5rem;

                img {
                  width: 40px;
                  height: 40px;
                  object-fit: cover;
                  border-radius: 8px;
                  margin-right: 1rem;
                }
              }

              p {
                margin: 0;
                font-size: 14px;
              }

              button {
                position: absolute;
                bottom: -1rem;
              }
            }

            .social {
              margin-top: 5rem;

              h3 {
                font-family: 'Creighton';
                font-size: 35px;
                text-shadow: $purple-box-shadow;
                color: white;
              }

              .icons {
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin-top: 1.5rem;

                .icon {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 50px;
                  height: 50px;
                  background: $purple;
                  box-shadow: $purple-box-shadow;
                  border-radius: 500px;
                  cursor: pointer;

                  &:not(:last-child) {
                    margin-right: 1rem;
                  }
                }
              }
            }

            button {
              border-radius: $border-radius;
              box-shadow: $yellow-box-shadow;

              // animation: 1s ease-out 1 spin;

              &:disabled {
                opacity: .3;
                cursor: not-allowed;
              }
            }
          }

          .confetti-bottom {
            position: absolute;
            bottom: -2rem;
            width: 100%;
            height: 10rem;
            background-image: url('~@assets/images/confetti-stretch.png');
            background-size: cover;
            background-position: top;
            z-index: 0;
          }

          h1 {
            font-family: 'Creighton';
            font-size: 75px;
            text-shadow: $purple-box-shadow;
          }
        }
      }
    }
  }
}



.hint-enter {
  display: none;
  opacity: 0;
  filter: blur(4px);
}
.hint-enter-to {
  opacity: 1;
  filter: blur(0);
}
.hint-enter-active {
  display: block;
  transition: opacity 1.5s ease;
  transition-delay: 2s;
}


// .hint-leave {
//   opacity: 1;
//   filter: blur(0);
// }
// .hint-leave-to {
//   opacity: 0;
//   filter: blur(4px);
// }
// .hint-leave-active {
//   transition: opacity 1.5s ease;
//   transition-delay: 0s;
// }


// .hint-enter-active {
//   transition: opacity 1.5s ease;
//   transition-delay: 2s;
// }

// .hint-leave-active {
//   transition: opacity 1.5s ease;
// }

// .hint-enter-from,
// .hint-leave-to {
//   opacity: 0;
//   filter: blur(4px);
// }






.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}













.card-enter-active,
.card-leave-active {
  transition: all .3s ease;

  .transition-wrapper {
    transform: translateY(140px);
  }
}

.card-enter-from,
.card-leave-to {
  opacity: 0;

  .transition-wrapper {
    transform: translateY(140px);
  }
}

.card-enter-to {
  .transition-wrapper {
    transform: translateY(0px);
  }
}







@keyframes spin {
  0%   { transform: rotate(0deg); opacity: 0; }
  100% { transform: rotate(1800deg); opacity: 1; }
}
</style>